export enum ChoosePacksFlows{
    CHANGE_PACKS= 'changePack',
    CLAIM_PACKS = 'claimPack',
    BOGO_OFFER = 'bogoOffer'
}